import type { SubscriptionPlan } from "@/api/tenants";

/**
 * Returns the cheapest plan whose module_features enables `feature`,
 * or null if none do / plans not loaded. Ties broken by sort_order.
 */
export function minPlanForFeature(
  feature: string,
  plans: SubscriptionPlan[] | undefined,
): SubscriptionPlan | null {
  if (!plans || plans.length === 0) return null;
  const including = plans.filter((p) => p.module_features?.[feature] === true);
  if (including.length === 0) return null;
  return including.reduce((best, p) => {
    const bestPrice = Number(best.price_monthly) || 0;
    const price = Number(p.price_monthly) || 0;
    if (price !== bestPrice) return price < bestPrice ? p : best;
    return (p.sort_order ?? 0) < (best.sort_order ?? 0) ? p : best;
  });
}
